var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChaingunTurret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.1853 28.7461L42.8648 28.3666C42.8648 28.3666 44.6423 24.7486 48.4718 24.2416",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.158 37.3201C116.158 37.3201 116.263 36.3466 116.282 35.2936C116.302 34.2406 115.556 32.9146 115.28 32.1136C115.004 31.3126 115.151 30.8236 115.313 30.3586C115.475 29.8936 116.158 29.5921 116.158 29.5921V28.8316L115.271 27.9031L114.215 27.6076L111.512 30.2686L111.23 32.6581L109.42 30.5506L107.663 29.8756L108.217 28.9186L107.372 27.8206L106.13 27.7366L104.965 28.7926L101.164 27.4831L97.9118 27.6091L97.2789 27.3556L96.3923 28.0741L89.7954 27.5011L79.4993 26.6056L67.6179 26.1031V21.5986H63.9579L62.5163 22.8421L63.4613 18.8671L63.1134 18.1066L63.5634 17.4316C63.5634 17.4316 63.8738 15.6076 63.9368 15.1696C63.9998 14.7316 63.2259 14.1091 63.2259 14.1091L57.6503 14.5036L57.8198 12.4771C57.8198 12.4771 57.8318 9.28505 57.6503 8.87255C57.4688 8.46155 55.2294 9.37955 55.2294 9.37955L53.4324 12.9856C53.4324 12.9856 50.5268 18.7681 49.7798 20.2231C49.0313 21.6781 48.4718 24.2461 48.4718 24.2461C44.6423 24.7531 42.8648 28.3711 42.8648 28.3711L42.1853 28.7506H21.4404L20.7084 28.0741L14.5419 28.0546L13.4439 28.4671H11.9664L11.5869 29.0941H8.63035L6.77185 30.1966H2.54785V38.8426L3.77335 39.7711H5.12485L5.67385 38.8426H6.56035L8.54485 40.3636L10.1544 40.4236L12.8979 44.4286L11.8209 44.7271L12.2799 45.5926L12.8544 46.6996L19.6569 46.4206L19.9494 45.8116L21.1749 45.4186L50.5269 45.0931L51.3939 45.5161L51.4134 46.4446L49.9628 46.9126L49.4769 47.6611L56.1218 48.8161L57.5363 48.3166C57.5363 48.3166 58.5068 48.3511 59.2058 48.2596C59.9048 48.1681 60.2394 47.6266 60.2394 47.6266L63.1538 49.4851L64.1394 49.4416L64.8429 48.8086L63.7509 47.7811L62.8163 46.4011L61.9433 45.5146L66.7868 45.4726L67.9628 47.0356L67.9269 49.0621L69.3624 51.4276L71.3468 51.3436L72.2768 51.8836L81.4118 51.5041L81.5678 50.3296L82.2008 49.3576L82.2428 45.7681L84.2693 44.2906L85.5789 44.3281L86.4653 44.7976H90.8153C90.8153 44.7976 93.8558 43.1296 95.6408 42.1891C97.4258 41.2486 99.7268 41.7076 99.7268 41.7076L110.75 41.5876L116.579 39.0106V38.0386L116.156 37.3201H116.158ZM103.459 37.2781L102.698 38.1226H100.643L100.081 38.6296H95.7173L95.1548 38.0386H94.8173V37.1101H99.2948C99.2948 37.1101 99.8303 36.9976 100.28 36.8566C100.73 36.7156 101.716 36.6601 101.969 36.4066L102.223 36.1531H102.955L103.462 36.6316V37.2796L103.459 37.2781ZM104.501 33.4351H97.4063C97.3223 32.0131 98.3348 32.0701 98.3348 32.0701L99.7988 32.0131L100.334 31.7041C100.87 31.3951 100.447 30.9436 100.447 30.9436H99.9969C99.9969 30.9436 99.9129 30.5206 99.9399 30.2401C99.9684 29.9581 100.136 29.8741 100.136 29.8741L100.952 30.0016C100.952 30.0016 102.416 30.4381 103.205 30.6916C103.994 30.9451 103.825 31.3951 103.825 31.3951L103.853 32.4091L104.501 33.0001V33.4366V33.4351ZM111.23 37.2781V37.7566L109.879 38.7991H108.499V37.2511L108.245 36.9136V35.7586H111.23L110.71 36.1531V36.7591L111.23 37.2796V37.2781Z",
    fill: "#FAFAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4824 41.7061H28.4809",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5508 41.7061H33.5493",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6172 41.7061H38.6172",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6855 41.7061H43.6841",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7549 41.7061H48.7534",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.823 41.7061H53.8215",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5293 43.6411H30.5278",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5977 43.6411H35.5962",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.665 43.6411H40.6635",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7336 43.6411H45.7321",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8018 43.6411H50.8003",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2056 37.9395C43.3224 37.9395 43.4171 37.8448 43.4171 37.728C43.4171 37.6112 43.3224 37.5165 43.2056 37.5165C43.0888 37.5165 42.9941 37.6112 42.9941 37.728C42.9941 37.8448 43.0888 37.9395 43.2056 37.9395Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5328 37.9395C52.6496 37.9395 52.7443 37.8448 52.7443 37.728C52.7443 37.6112 52.6496 37.5165 52.5328 37.5165C52.416 37.5165 52.3213 37.6112 52.3213 37.728C52.3213 37.8448 52.416 37.9395 52.5328 37.9395Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1558 43.6606C62.2726 43.6606 62.3673 43.5659 62.3673 43.4491C62.3673 43.3323 62.2726 43.2376 62.1558 43.2376C62.039 43.2376 61.9443 43.3323 61.9443 43.4491C61.9443 43.5659 62.039 43.6606 62.1558 43.6606Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1558 40.8436C62.2726 40.8436 62.3673 40.7489 62.3673 40.6321C62.3673 40.5153 62.2726 40.4206 62.1558 40.4206C62.039 40.4206 61.9443 40.5153 61.9443 40.6321C61.9443 40.7489 62.039 40.8436 62.1558 40.8436Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2056 30.9991C43.3224 30.9991 43.4171 30.9044 43.4171 30.7876C43.4171 30.6708 43.3224 30.5761 43.2056 30.5761C43.0888 30.5761 42.9941 30.6708 42.9941 30.7876C42.9941 30.9044 43.0888 30.9991 43.2056 30.9991Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7213 37.9395C24.8381 37.9395 24.9328 37.8448 24.9328 37.728C24.9328 37.6112 24.8381 37.5165 24.7213 37.5165C24.6045 37.5165 24.5098 37.6112 24.5098 37.728C24.5098 37.8448 24.6045 37.9395 24.7213 37.9395Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7213 30.9991C24.8381 30.9991 24.9328 30.9044 24.9328 30.7876C24.9328 30.6708 24.8381 30.5761 24.7213 30.5761C24.6045 30.5761 24.5098 30.6708 24.5098 30.7876C24.5098 30.9044 24.6045 30.9991 24.7213 30.9991Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5328 30.9991C52.6496 30.9991 52.7443 30.9044 52.7443 30.7876C52.7443 30.6708 52.6496 30.5761 52.5328 30.5761C52.416 30.5761 52.3213 30.6708 52.3213 30.7876C52.3213 30.9044 52.416 30.9991 52.5328 30.9991Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2705 32.6566V36.1516H30.9015L32.31 35.8981V34.8076H33.831V33.8071H32.3235L31.437 32.6566H25.2705Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0936 32.0491H16.7966V37.5181H22.9346L23.2166 36.5746H24.7226V34.8856L24.1451 34.5181C24.1451 34.5181 24.2576 34.2661 23.7221 33.0271C23.1866 31.7881 21.9761 31.1131 21.9761 31.1131H15.1631V29.3116H21.5831",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3167 33.7306V35.7856L18.9077 36.4336H20.9357L21.5822 35.9266V33.7306L20.9492 33.0541H19.0352L18.3167 33.7306Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2051 28.071V40.3605",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.699 27.9871V32.1136H73.671L77.8515 30.0001V27.9871H72.699Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7086 28.3666L80.8936 29.4646",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.293 37.3906L71.7705 36.1516H74.037L75.5295 37.4191",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0186 45.7036H68.7706L72.6991 43.8241C72.6991 43.8241 73.8961 42.9796 75.1351 43.8241C76.3741 44.6686 79.9636 47.0341 79.9636 47.0341L82.2436 45.7666",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9231 43.0636L80.4571 45.5131",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2928 43.0635L67.7158 44.5005",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0608 46.0411L56.1223 47.7796L52.3213 47.4136L53.0608 46.0411Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4785 30.0001V28.1551L67.7165 26.1046",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.323 27.7336H70.9265C70.9265 27.7336 71.6015 27.8176 71.645 28.3666C71.6885 28.9156 70.8425 28.9156 70.8425 28.9156H65.4785",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8451 37.1086H60.6211V38.3761H64.8451V37.1086Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8018 34.4041H55.8478",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0322 25.4805L56.1222 17.3715H57.1992L55.1157 25.4805H53.0322Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54785 30.195H6.77185L8.63035 29.0925H11.1639L11.5869 28.4655H13.4454L14.0079 28.071H20.7084L21.4404 28.746H42.6699C42.6699 28.746 44.2464 25.086 48.4704 24.2415C48.4704 24.2415 49.2023 21.2565 49.9343 19.905C50.6663 18.5535 55.2279 9.37504 55.2279 9.37504C55.2279 9.37504 57.0863 8.64304 57.6488 8.86804C58.2113 9.09304 57.6488 14.499 57.6488 14.499L63.2243 14.1045C63.2243 14.1045 63.9564 14.667 63.9564 14.949C63.9564 15.231 63.5618 17.427 63.5618 17.427C63.5618 17.427 63.1673 17.652 63.1118 18.102C63.0563 18.552 63.5064 18.6675 63.5064 18.6675L62.1548 24.3525L63.9564 21.5925H67.6163V26.097L78.9068 26.547L96.3923 28.068L97.2789 27.3495L97.9118 27.603H99.1793L101.164 27.477L104.965 28.7865L106.316 27.561L106.823 27.8565L107.372 27.8145L108.217 28.617V29.292L107.542 29.997C107.542 29.997 108.556 29.757 109.484 30.6015C110.413 31.446 111.511 32.7135 111.511 32.7135V30.264L114.214 27.603L115.27 27.8985L116.156 28.827V29.5875C116.156 29.5875 115.481 29.925 115.228 30.516C114.974 31.107 115.228 32.4585 115.903 33.5985C116.578 34.7385 116.156 37.3155 116.156 37.3155L116.579 37.7385V39.006L113.581 40.569L110.752 41.583H99.3068C99.3068 41.583 96.9413 41.457 95.1263 42.4275C93.3098 43.3995 90.9879 44.793 90.9879 44.793H86.2583L85.7934 44.328L84.1043 44.286C84.1043 44.286 83.6393 44.5395 83.6813 44.793C83.7233 45.0465 82.8368 45.258 82.8368 45.258L82.2458 45.765V49.566L81.5708 50.3265L81.6129 51.4245L81.0638 51.636L71.9408 51.8895L71.3499 51.3405L69.3653 51.4245C69.3653 51.4245 68.6903 50.8335 68.3093 49.947L67.9298 49.0605L67.9718 46.653L66.7898 45.471L60.8769 45.2595L62.8193 46.3995C62.8193 46.3995 63.2843 46.8225 63.4103 47.286C63.5363 47.7495 64.4243 48.3 64.4243 48.3L65.0993 48.765C65.0993 48.765 65.1413 49.23 64.6763 49.356C64.2113 49.482 63.1554 49.482 63.1554 49.482L60.2408 47.6235C60.2408 47.6235 59.9033 47.412 59.5658 47.877C59.2283 48.342 59.1864 48.3 58.6794 48.342C58.1724 48.384 57.3279 48.216 57.3279 48.216L56.5253 48.807C56.5253 48.807 54.6248 48.891 52.5128 48.4695C50.4008 48.0465 49.8939 47.8785 49.8939 47.8785C49.8939 47.8785 49.1334 47.625 49.3449 47.2455C49.5564 46.866 50.2314 46.8225 50.4849 46.8225C50.7384 46.8225 51.2034 46.9065 51.4134 46.443C51.6249 45.978 51.4554 45.2175 50.9064 45.0915C50.3574 44.9655 20.3709 45.429 20.3709 45.429C20.3709 45.429 19.9914 45.513 19.9479 45.7665C19.9044 46.02 20.2014 46.4415 19.3569 46.4415C18.5124 46.4415 17.2449 46.3995 17.2449 46.3995C17.2449 46.3995 16.4844 46.3575 15.9354 46.569L12.8529 46.695C12.8529 46.695 12.3039 46.4835 12.3039 45.9345C12.3039 45.3855 12.1344 44.9625 11.8389 44.9625L11.7969 44.4555L13.2324 44.4135L10.1064 40.359H8.54335L6.81235 38.838H5.67235L5.12335 39.7665H3.77185L3.22285 39.3015V38.922H2.54785V35.8815H3.09685V34.953H2.54785V30.192V30.195Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77148 30.1951V38.8411",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62988 29.0911V40.3606",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5869 28.4655V40.065",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1074 40.3606H14.2459L15.3859 42.5986C15.3859 42.5986 15.5554 43.4851 16.4419 43.4851H21.1714V40.0636H53.8189V42.2176C53.8189 42.2176 53.7769 42.9781 54.4519 43.1896C54.4519 43.1896 54.4099 44.7946 55.8454 45.0901H50.9044",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1552 24.354L59.9997 30.195L59.2542 30.732C59.2542 30.732 58.4232 31.788 58.2972 33.435C58.1712 35.082 58.2972 43.8675 58.2972 43.8675L60.8742 45.261",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6719 28.746H53.7794C53.7794 28.746 54.7079 28.788 54.8354 29.718C54.9629 30.648 55.3004 31.5765 55.5959 32.0835C55.8914 32.5905 55.8914 33.0975 55.8494 34.3635C55.8074 35.631 55.3844 38.2485 53.8229 40.065",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4707 24.2415C48.4707 24.2415 50.7372 23.847 51.4557 23.847V28.746",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 30.1951H65.7582L70.0377 33.5341V35.8426L67.9542 37.4191H66.2082V35.5051C66.2082 35.5051 66.2082 34.4071 64.4622 34.4071H58.2402",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4062 33.4351H104.501V32.9986L103.853 32.4076L103.825 31.3936C103.825 31.3936 103.994 30.9436 103.205 30.6901C102.416 30.4366 100.952 30.0001 100.952 30.0001L100.136 29.8726C100.136 29.8726 99.9667 29.9566 99.9397 30.2386C99.9112 30.5206 99.9967 30.9421 99.9967 30.9421H100.447C100.447 30.9421 100.87 31.3921 100.334 31.7026L99.7987 32.0116L98.3347 32.0686C98.3347 32.0686 97.3207 32.0116 97.4062 33.4336V33.4351Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8154 37.1085H99.2929C99.2929 37.1085 99.8284 36.996 100.278 36.855C100.728 36.714 101.714 36.6585 101.967 36.405L102.221 36.1515H102.953L103.46 36.63V37.278L102.699 38.1225H100.644L100.082 38.6295H95.7184L95.1559 38.0385H94.8184V37.11L94.8154 37.1085Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M108.245 35.7571V36.9121L108.499 37.2496V38.7991H109.879L111.23 37.7566V37.2781L110.71 36.7576V36.1516L111.23 35.7571H108.245Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M104.501 33.4351H109.006L108.106 32.4346L103.459 30.7921",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M100.137 29.8726V27.5446",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M111.512 32.7166C111.512 32.7166 112.328 33.2236 112.469 34.2376C112.61 35.2516 112.385 35.7016 112.187 35.7586C111.989 35.8156 111.23 35.7586 111.23 35.7586",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M108.245 35.757H102.446",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8156 38.0386H80.4561V39.5581H90.6201V42.6001H83.5806L82.7931 43.2466V45.2596",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2019 39.558V41.649H67.7854C67.7854 41.649 65.8429 42.072 65.8714 40.6035V39.8685H75.0214",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1348 41.6491V38.0386L76.5148 37.1656V35.8981H83.8633V38.0386",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8155 37.1086V34.0261L94.322 34.0306L74.9375 34.2376V33.0541L79.751 30.5491H94.0265L95.927 32.1136H98.3345",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3225 34.0305V32.1135L93.52 31.281H88.579L86.6785 32.1135H82.666L81.8215 32.421H76.1455",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5985 50.3985C76.0449 50.3985 77.2175 49.226 77.2175 47.7795C77.2175 46.3331 76.0449 45.1605 74.5985 45.1605C73.1521 45.1605 71.9795 46.3331 71.9795 47.7795C71.9795 49.226 73.1521 50.3985 74.5985 50.3985Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5987 48.315C74.8945 48.315 75.1342 48.0753 75.1342 47.7795C75.1342 47.4838 74.8945 47.244 74.5987 47.244C74.303 47.244 74.0632 47.4838 74.0632 47.7795C74.0632 48.0753 74.303 48.315 74.5987 48.315Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaingunTurret);
export default __webpack_public_path__ + "static/media/Chaingun Turret.52d347a38c7131ae7d23369725d5542d.svg";
export { ForwardRef as ReactComponent };